<template>
  <div class="center__wrapper">
    <component v-if="component" :is="component" v-bind="componentProps" />
    <div v-else class="styled-label">Not a component...</div>
  </div>
</template>

<script>
export default {
  name: 'AppComponentSandbox',
  computed: {
    component () {
      return this.$route.params.component
    },
    componentProps () {
      const params = this.$route.query
      return params
    }
  }
}
</script>

<style scoped>
.center__wrapper {
  display: flex;

  height: 100%;
  width: 100%;

  align-content: center;
  align-items: center;
  justify-content: center;
}

.styled-label {
  padding: 0.35rem;
  font-family: "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Open Sans", "Helvetica Neue", "sans-serif";
}
</style>
